import clsx from "clsx";

import { InformationCircleIcon } from "@heroicons/react/24/outline";

import { ITitleConfigRequest } from "../../models/Category/TitleConfig";

const MAX_INSTRUCTIONS_LENGTH = 4000;

interface AdditionalInstructionsPanelProps {
  categoryName: string;
  config: ITitleConfigRequest;
  onChange: (patch: Partial<ITitleConfigRequest>) => void;
}

export default function AdditionalInstructionsPanel({
  categoryName,
  config,
  onChange,
}: AdditionalInstructionsPanelProps) {
  const length = config.additionalInstructions?.length ?? 0;
  const overLimit = length > MAX_INSTRUCTIONS_LENGTH;

  return (
    <section className="bg-white rounded shadow-sm border border-gray-200 p-4">
      <h2 className="text-xs font-semibold tracking-wide text-gray-500 uppercase mb-3">
        Additional Instructions
      </h2>

      <label className="block text-sm font-medium opacity-80 mb-1">
        Title instructions for {categoryName}
      </label>
      <textarea
        rows={6}
        value={config.additionalInstructions ?? ""}
        onChange={(e) =>
          onChange({ additionalInstructions: e.currentTarget.value })
        }
        placeholder="e.g. Always use Wing Mirror rather than Door Mirror."
        className={clsx(
          "w-full rounded border px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-orange-600",
          overLimit ? "border-red-500" : "border-orange-600",
        )}
      />
      <div
        className={clsx(
          "mt-1 text-right text-xs",
          overLimit ? "text-red-600" : "text-gray-500",
        )}
      >
        {length} / {MAX_INSTRUCTIONS_LENGTH}
      </div>

      <div className="mt-3 flex gap-2 rounded border border-gray-200 bg-gray-50 p-2 text-xs text-gray-600">
        <InformationCircleIcon className="h-4 w-4 shrink-0 text-gray-400" />
        <span>
          Added to the end of the title prompt for this category. The AI
          follows these over the general rules, but never at the expense of
          the character limit. Leave blank for none.
        </span>
      </div>
    </section>
  );
}
